import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_engage_proactively_w_relevant_stakeholders_before'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_engage_proactively_w_relevant_stakeholders_before',
  name: 'Does the facility engage proactively with relevant stakeholders before an investment is made in a new land?',
  description:
    'If the facility has not made an investment in a new land during the assessment period, answer Not Applicable.',
  meta: {},
  fieldTypeId: 'SELECT_WITH_FOLLOW_UP',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'ynna',
      followUp: [
        {
          fieldType: 'SHORT_TEXT',
          text: 'If yes, please describe:',
          externalIds: [
            {
              id: 'ab-13--1-1f',
              version: '1.4.0',
              provider: 'slcp',
            },
          ],
        },
      ],
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'ynna',
    },
    {
      name: 'Not Applicable',
      key: 'NOT_APPLICABLE',
      slcpIndex: 3,
      slcpOptionName: 'ynna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'object',
        properties: {
          value: {
            type: 'string',
            enum: ['YES', 'NO', 'NOT_APPLICABLE'],
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['value', 'followUp'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ab-13--1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 25350,
  sectionId: '2.2.2.3',
  impactArea: 'Community Engagement',
  impactAreaId: 'COMMUNITY_ENGAGEMENT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
